import { render, staticRenderFns } from "./MagicToken.vue?vue&type=template&id=52e5d7eb&scoped=true"
import script from "./MagicToken.vue?vue&type=script&lang=js"
export * from "./MagicToken.vue?vue&type=script&lang=js"
import style0 from "./MagicToken.vue?vue&type=style&index=0&id=52e5d7eb&prod&scoped=true&lang=css"
import style1 from "./MagicToken.vue?vue&type=style&index=1&id=52e5d7eb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e5d7eb",
  null
  
)

export default component.exports